import { LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupAddMember" */ './lazyIndex');
});
export var lazyAddGroupMember = new LazyImport(lazyModule, function (m) { return m.addGroupMember; });
//# sourceMappingURL=index.js.map